import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CheckboxGroupDirective } from "./checkbox-group/checkbox-group.directive";
import { SubmitFormDirective } from "./submit-form/submit-form.directive";

@NgModule({
	imports: [CheckboxGroupDirective, CommonModule, SubmitFormDirective],
	exports: [SubmitFormDirective, CheckboxGroupDirective],
})
export class FormsDirectivesModule {}
